export default {
    title: "Eventos Personalizados",
    empty_message: "Aún no tienes ningún Evento,",
    empty_action: "¡crea el primero ahora!",
    new_event_button: "Nuevo Evento",
    search_placeholder: "Buscar eventos...",
    no_results_found: 'No se encontraron eventos para "<strong>{0}</strong>".',
    clear_search: "Limpiar búsqueda",
    save_success: "Guardado con éxito",
    save_button: "Guardar",
    page_title: "Kevi | Eventos Personalizados",
    event_title_label: "Título del Evento",
    event_title_placeholder: "Título del Evento",
    cannot_edit_warning:
        "Este evento tiene una o más ocurrencias registradas en el sistema y no se puede eliminar ni cambiar su título.",
    registrations_count: "{0} ocurrencia del evento registrada",
    registrations_count_plural: "{0} ocurrencias del evento registradas",
    archive_event: "Archivar evento",
    remove_notice: 'El Evento "{0}" se eliminará al guardar.',
    undo: "Deshacer",
    register_event_button: "Registrar Evento",
    register_event_title: "Registrar Evento",
    search_event_placeholder: "Buscar evento...",
    no_events_created: "No hay eventos personalizados creados por el momento",
    create_event_button: "Crear Evento",
    register_confirmation_title: "¿Desea registrar el evento?",
    register_confirmation_body:
        'Esta acción es irreversible y agregará el evento personalizado <strong>"{0}"</strong> a la línea de tiempo de este cliente.',
    register_success: "¡Evento personalizado registrado con éxito!",
    register_error: "Error al registrar el evento personalizado.",
};
